import PreviewCardSkeletonState from '../../preview-card/components/PreviewCardSkeletonState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadListMemberSidebarSkeletonState = () => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "ThreadListMemberSidebarSkeletonState",
    children: [/*#__PURE__*/_jsx(PreviewCardSkeletonState, {}), /*#__PURE__*/_jsx(PreviewCardSkeletonState, {}), /*#__PURE__*/_jsx(PreviewCardSkeletonState, {}), /*#__PURE__*/_jsx(PreviewCardSkeletonState, {})]
  });
};
ThreadListMemberSidebarSkeletonState.displayName = 'ThreadListMemberSidebarSkeletonState';
export default ThreadListMemberSidebarSkeletonState;